import { render, staticRenderFns } from "./switchCard.vue?vue&type=template&id=587b51a4&scoped=true&"
import script from "./switchCard.vue?vue&type=script&lang=js&"
export * from "./switchCard.vue?vue&type=script&lang=js&"
import style0 from "./switchCard.vue?vue&type=style&index=0&id=587b51a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587b51a4",
  null
  
)

component.options.__file = "switchCard.vue"
export default component.exports